import { render, staticRenderFns } from "./Dedupes.vue?vue&type=template&id=aa867838"
import script from "./Dedupes.vue?vue&type=script&setup=true&lang=js"
export * from "./Dedupes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Dedupes.vue?vue&type=style&index=0&id=aa867838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports